module.exports = __webpack_public_path__ + "img/refused.0d4e9879.svg";